import * as React from 'react';
import { ClustersLayout } from './components/ClustersLayout';
import { UIHeading1 } from '@cian/ui-kit';
import { ClusterContainer } from './ClusterContainer';
import { selectIsMoscowOrMO } from '../../selectors/locations/selectIsMoscowOrMO';
import { useSelector } from 'react-redux';
import { clusters } from '../../constants/cluster';

export function ClustersContainer() {
  const isMoscowOrMO = useSelector(selectIsMoscowOrMO);

  const [activeTab, setActiveTab] = React.useState(clusters[0].id);

  const preparedTabs = React.useMemo(() => clusters.map(cluster => ({ title: cluster.title, value: cluster.id })), []);
  const activeCluster = React.useMemo(() => clusters.find(cluster => cluster.id === activeTab), [activeTab]);

  if (!isMoscowOrMO) {
    return null;
  }

  return (
    <ClustersLayout
      title={<UIHeading1>Матвеевский кластер</UIHeading1>}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      tabs={preparedTabs}
      tabContent={<ClusterContainer cluster={activeCluster} />}
    />
  );
}
